import React from 'react';
import { logger } from '@belong/logging/logger';
import { Asset, BLOCKS } from '@belong/types/cms';
import { Image, Video } from './styles';

type Props = {
  asset: Asset;
};

const RenderBlockAsset: React.FC<Props> = ({ asset }) => {
  const { description } = asset.fields;
  const { contentType, url } = asset.fields.file;

  const isImage = /^image\//.test(contentType);
  if (isImage) {
    return <Image src={url} alt={description} />;
  }

  const isVideo = /^video\//.test(contentType);
  if (isVideo) {
    return (
      <Video controls>
        <source src={url} type={contentType} />
      </Video>
    );
  }

  logger.error(`[${BLOCKS.EMBEDDED_ASSET}]: cannot render "${contentType}"`);

  return null;
};

RenderBlockAsset.displayName = 'RenderBlockAsset';

export default RenderBlockAsset;
